/**
 * ToDo: Move QR Modal to a separate component
 */

import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PrimaryButton from "views/components/button/PrimaryButton";
import { saveAs } from "file-saver";
import copy from "clipboard-copy";
import html2canvas from "html2canvas";
import { getDataURL } from "views/download/helpers";
import QRCode from "react-qr-code";
import DefaultSwitch from "views/components/input/DefaultSwitch";
import Spinner from "views/components/loader/Spinner";
import { clearBranchLink } from "redux-store/slices/globals";
import { Modal } from "react-bootstrap";
import {
  GET_BRANCH_URL,
  GET_BUSINESS_BRANDING,
  GET_BRANCH_WEB_URL,
  SEND_USER_CLICK_ANALYTICS,
} from "redux-store/sagas/saga-actions";
import { toast } from "react-toastify";
import { getLocalStorageUser } from "utils/helpers/localstorage";
import CopyButton from "../button/CopyButton";
import SecondaryButton from "../button/SmallRoundedButton";
import OutlinedButton from "../button/OutlinedButton";
import ConfirmationModal from "./ConfirmationModal";
import css from "./css/GroupShare.module.css";
import ANALYTICS from "constants/analyticsKeys";
import { privGPA, pubGFA } from "utils/helpers/group-share-messages";

const QR_INIT = { design: "", noDesign: "" };

const GroupShareModal = ({
  show,
  groupDetails,
  branding,
  isPrivate,
  isAdmin,
  onHide,
}) => {
  const user = getLocalStorageUser();
  const isPhotographer = user?.userType === "PHOTOGRAPHER";
  const {
    settingLoader,
    businessBranding: { business_name },
  } = useSelector((state) => state.settings);
  const { branchLink, globalLoading } = useSelector((state) => state.globals);
  const [QRModalShow, setQRModalShow] = React.useState(false);
  const [QRCodeImage, setQRCodeImage] = React.useState(QR_INIT);
  const [logo, setLogo] = React.useState({
    logo: branding?.logo,
    kwikpicLogo: "/assets/images/global-images/logo2.png",
  });
  const [fullAccess, setFullAccess] = React.useState(false);
  const [forApp, setForApp] = React.useState(true);
  const QRRef = React.useRef();
  const QRNoDesign = React.useRef();

  const isAnonymous = location.href.includes("anonymousUserId");

  const handleCopy = (msg) => {
    if (msg) {
      copy(msg);
      toast.success("Message Copied to Clipboard");

      if (!isAnonymous)
        dispatch({
          type: SEND_USER_CLICK_ANALYTICS,
          payload: { buttons: [ANALYTICS.SHARE_INVITE_LINKS] },
        });
    }
  };

  const handlePrintQR = () => {
    setQRModalShow(true);
  };

  const downloadQR = () => {
    saveAs(
      QRCodeImage.design,
      `kwikpic-qr-${groupDetails.name}-${forApp ? "app" : "web"}-${
        fullAccess ? "full" : "partial"
      }.png`
    );
  };

  const downloadQRNoDesign = () => {
    saveAs(
      QRCodeImage.noDesign,
      `kwikpic-qr-${groupDetails.name}-${forApp ? "app" : "web"}-${
        fullAccess ? "full" : "partial"
      }-no-design.png`
    );
  };

  const dispatch = useDispatch();

  let name = isPhotographer ? business_name : `${user.name} ${user.lastName}`;
  if (isAnonymous) name = "Anonymous User";

  const pubAdm = pubGFA(
    name,
    groupDetails.name,
    groupDetails.branchURL || groupDetails.groupLink,
    branchLink,
    groupDetails.adminToken,
    groupDetails.groupCode,
    groupDetails.fGroupCode
  );

  const pubParPriv = privGPA(
    name,
    groupDetails.name,
    groupDetails.branchURL || groupDetails.groupLink,
    branchLink,
    groupDetails.groupCode
  );

  useEffect(() => {
    getDataURL(branding?.logo, function (uri) {
      setLogo((p) => ({ ...p, logo: uri }));
    });
    getDataURL("/assets/images/global-images/logo2.png", function (uri) {
      setLogo((p) => ({ ...p, kwikpicLogo: uri }));
    });
  }, [branding?.logo]);

  useEffect(() => {
    if (QRRef.current) {
      QRRef.current.style.height = "508px";
      QRRef.current.style.width = "290px";
      QRRef.current.style.transform = "scale(0.85)";
      QRRef.current.style.transformOrigin = "top center";
      QRRef.current.style.top = "0";

      QRRef.current.parentElement.style.height = 508 * 0.85 + "px";

      html2canvas(QRRef.current, { logging: false, scale: 3.5 }).then(
        (canvas) => {
          setQRCodeImage((p) => ({
            ...p,
            design: canvas.toDataURL("image/png"),
          }));
        }
      );
    }

    if (QRNoDesign.current) {
      html2canvas(QRNoDesign.current, { logging: false, scale: 4 }).then(
        (canvas) => {
          setQRCodeImage((p) => ({
            ...p,
            noDesign: canvas.toDataURL("image/png"),
          }));
        }
      );
    }
  }, [QRModalShow, logo, fullAccess, forApp]);

  useEffect(() => {
    dispatch({
      type: GET_BRANCH_URL,
      payload: {
        title: groupDetails.name,
        uCode: groupDetails.groupCode,
        icon: groupDetails.icon,
      },
    });
    dispatch({
      type: GET_BRANCH_WEB_URL,
      payload: {
        title: groupDetails.name,
        link: "auth/login",
        icon: groupDetails.icon,
      },
    });
    if (isPhotographer) {
      dispatch({
        type: GET_BUSINESS_BRANDING,
      });
    }

    return () => dispatch(clearBranchLink());
  }, []);

  const AccessTypes = ({ full, isPrivate }) => {
    return (
      <div className="modal-bordered-wrapper position-relative">
        <CopyButton
          title={
            isPrivate
              ? groupDetails?.groupCode
              : full
              ? groupDetails?.fGroupCode
              : groupDetails?.groupCode
          }
          copyText={
            isPrivate
              ? groupDetails?.groupCode
              : full
              ? groupDetails?.fGroupCode
              : groupDetails?.groupCode
          }
          className="position-absolute color-gray top-0 end-0 mt-2 me-2 bg-transparent px-2 py-2 rounded shadow-sm font-bold font-14 copy-button"
        />
        <p className="font-18 color-primary font-bold m-0">
          {full ? "Full" : "Partial"} Access
        </p>
        <p className="share-content mt-2 mt-sm-0">
          People who join using this link can -
        </p>
        <ul className="share-content-list">
          <li>
            <img
              src="/assets/icons/tick-blue.png"
              alt="tick"
              className="me-2 mb-1 info-icon"
            />
            Face recognition - View OWN photos
          </li>
          <li>
            <img
              src="/assets/icons/tick-blue.png"
              alt="tick"
              className="me-2 mb-1 info-icon"
            />
            View highlights folder
          </li>
          <li>
            <img
              src={`/assets/icons/${full ? "tick-blue" : "cross"}.png`}
              alt={full ? "tick-blue" : "cross"}
              className="me-2 mb-1 info-icon"
            />
            View all photos and folders
          </li>
        </ul>
        <div className="d-flex align-items-start gap-12">
          <SecondaryButton
            variant="md"
            rounded={false}
            className="px-3 max-180"
            onClick={() =>
              !isPrivate && full ? handleCopy(pubAdm) : handleCopy(pubParPriv)
            }
          >
            <div className="lh-1 d-flex align-items-center">
              <img
                src="/assets/images/icons/copy-white.png"
                alt="copy"
                className="me-2"
                height={16}
              />
              <p className="m-0 font-14 font-md-16">Invite Links</p>
            </div>
          </SecondaryButton>
          <PrimaryButton
            onClick={() => {
              handlePrintQR();
              setFullAccess(full);
              setQRCodeImage(QR_INIT);

              if (!isAnonymous)
                dispatch({
                  type: SEND_USER_CLICK_ANALYTICS,
                  payload: { buttons: [ANALYTICS.SHARE_PRINT_QR] },
                });
            }}
            title="Print QR"
            isButton={true}
          />
        </div>
      </div>
    );
  };

  const getLink = () => {
    let baseURL = forApp
      ? groupDetails?.branchURL || groupDetails.groupLink
      : `${branchLink}?uCode=${groupDetails.groupCode}`;

    if (fullAccess && !isPrivate)
      baseURL += `&adminToken=${groupDetails.adminToken}`;

    return baseURL;
  };

  return (
    <>
      <Spinner loading={settingLoader || globalLoading} />
      <Modal
        show={show}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={onHide}
      >
        <Modal.Body className="position-relative">
          <img
            src="/assets/images/icons/close.png"
            className="modal-wrapper-closeIcon"
            onClick={onHide}
          />
          <p className="title">Share Group Invite</p>
          {isPrivate ? (
            <AccessTypes full={true} isPrivate={true} />
          ) : (
            <>
              <AccessTypes full={false} />
              {isAdmin && <AccessTypes full={true} />}
            </>
          )}
          <div className="tutorial">
            <a
              href="https://www.youtube.com/watch?v=yDffgSp55SQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/assets/images/icons/group-join-tut.png"
                alt="group joining tutorial"
              />
            </a>
            <div>
              <p className="m-0">
                <a
                  href="https://www.youtube.com/watch?v=yDffgSp55SQ"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-17 color-primary font-bold"
                >
                  Group Joining Tutorial
                </a>
              </p>
              <p className="font-12 color-gray font-base m-0">1:30 minutes</p>
            </div>
            <div
              className="tut-share"
              onClick={() => {
                copy(
                  `Group joining demo in Hindi - https://cutt.ly/O81biwC\n\nGroup joining demo in English - https://cutt.ly/G81LvZ1`
                );
                toast.success("Link Copied to Clipboard");
              }}
            >
              <img src="/assets/images/icons/share-grouped.png" alt="share" />
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* QR modal */}
      <ConfirmationModal
        animation
        show={QRModalShow}
        footer={false}
        zIndex={1110}
        backdropClassName={css["qr-backdrop"]}
      >
        <div className="qr-wrapper pt-4 pb-3">
          {/* close icon */}
          <img
            src="/assets/images/icons/close.png"
            className="closeIcon"
            onClick={() => {
              setQRModalShow(false);
              setForApp(true);
            }}
          />
          <div className="pro-tip">
            <img src="/assets/images/icons/bulb.png" alt="bulb" />
            <span>Pro-tip: </span>
            Print the QR code in visiting card size (3.5x2 inch) and distribute
            it on the venue with every guest for best experience.
          </div>
          <div className="position-relative mt-3">
            <div className="model-box overflow-hidden p-3" ref={QRRef}>
              <div
                className="model-group-type-qr mb-2"
                style={{
                  maxWidth: "250px",
                  margin: "0 auto",
                  fontSize: "16px",
                }}
              >
                {groupDetails.name}
              </div>
              <div
                style={{
                  fontSize: "22px",
                  fontWeight: "600",
                  color: "#FF0000",
                  position: "relative",
                }}
                className="model-photos"
              >
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "-28px",
                  }}
                >
                  {forApp ? (
                    <svg
                      height="36"
                      viewBox="0 0 155 78"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M116 0H0V78H116L155 39L116 0Z" fill="#00599B" />
                      <path
                        d="M59.1338 33L65.7488 18.3H68.4368L75.0728 33H72.2168L66.5258 19.749H67.6178L61.9478 33H59.1338ZM62.1788 29.598L62.9138 27.456H70.8518L71.5868 29.598H62.1788ZM82.9063 33.147C81.9963 33.147 81.1633 32.937 80.4073 32.517C79.6653 32.097 79.0703 31.467 78.6223 30.627C78.1883 29.773 77.9713 28.695 77.9713 27.393C77.9713 26.077 78.1813 24.999 78.6013 24.159C79.0353 23.319 79.6233 22.696 80.3653 22.29C81.1073 21.87 81.9543 21.66 82.9063 21.66C84.0123 21.66 84.9853 21.898 85.8253 22.374C86.6793 22.85 87.3513 23.515 87.8413 24.369C88.3453 25.223 88.5973 26.231 88.5973 27.393C88.5973 28.555 88.3453 29.57 87.8413 30.438C87.3513 31.292 86.6793 31.957 85.8253 32.433C84.9853 32.909 84.0123 33.147 82.9063 33.147ZM76.6903 37.074V21.786H79.1893V24.432L79.1053 27.414L79.3153 30.396V37.074H76.6903ZM82.6123 30.9C83.2423 30.9 83.8023 30.76 84.2923 30.48C84.7963 30.2 85.1953 29.794 85.4893 29.262C85.7833 28.73 85.9303 28.107 85.9303 27.393C85.9303 26.665 85.7833 26.042 85.4893 25.524C85.1953 24.992 84.7963 24.586 84.2923 24.306C83.8023 24.026 83.2423 23.886 82.6123 23.886C81.9823 23.886 81.4153 24.026 80.9113 24.306C80.4073 24.586 80.0083 24.992 79.7143 25.524C79.4203 26.042 79.2733 26.665 79.2733 27.393C79.2733 28.107 79.4203 28.73 79.7143 29.262C80.0083 29.794 80.4073 30.2 80.9113 30.48C81.4153 30.76 81.9823 30.9 82.6123 30.9ZM97.3027 33.147C96.3927 33.147 95.5597 32.937 94.8037 32.517C94.0617 32.097 93.4667 31.467 93.0187 30.627C92.5847 29.773 92.3677 28.695 92.3677 27.393C92.3677 26.077 92.5777 24.999 92.9977 24.159C93.4317 23.319 94.0197 22.696 94.7617 22.29C95.5037 21.87 96.3507 21.66 97.3027 21.66C98.4087 21.66 99.3817 21.898 100.222 22.374C101.076 22.85 101.748 23.515 102.238 24.369C102.742 25.223 102.994 26.231 102.994 27.393C102.994 28.555 102.742 29.57 102.238 30.438C101.748 31.292 101.076 31.957 100.222 32.433C99.3817 32.909 98.4087 33.147 97.3027 33.147ZM91.0867 37.074V21.786H93.5857V24.432L93.5017 27.414L93.7117 30.396V37.074H91.0867ZM97.0087 30.9C97.6387 30.9 98.1987 30.76 98.6887 30.48C99.1927 30.2 99.5917 29.794 99.8857 29.262C100.18 28.73 100.327 28.107 100.327 27.393C100.327 26.665 100.18 26.042 99.8857 25.524C99.5917 24.992 99.1927 24.586 98.6887 24.306C98.1987 24.026 97.6387 23.886 97.0087 23.886C96.3787 23.886 95.8117 24.026 95.3077 24.306C94.8037 24.586 94.4047 24.992 94.1107 25.524C93.8167 26.042 93.6697 26.665 93.6697 27.393C93.6697 28.107 93.8167 28.73 94.1107 29.262C94.4047 29.794 94.8037 30.2 95.3077 30.48C95.8117 30.76 96.3787 30.9 97.0087 30.9ZM63.2884 60V44.418H65.9134V60H63.2884ZM69.3587 60V48.786H71.9837V60H69.3587ZM70.6817 46.938C70.1917 46.938 69.7857 46.784 69.4637 46.476C69.1557 46.168 69.0017 45.797 69.0017 45.363C69.0017 44.915 69.1557 44.544 69.4637 44.25C69.7857 43.942 70.1917 43.788 70.6817 43.788C71.1717 43.788 71.5707 43.935 71.8787 44.229C72.2007 44.509 72.3617 44.866 72.3617 45.3C72.3617 45.762 72.2077 46.154 71.8997 46.476C71.5917 46.784 71.1857 46.938 70.6817 46.938ZM81.792 48.66C82.688 48.66 83.486 48.835 84.186 49.185C84.9 49.535 85.46 50.074 85.866 50.802C86.272 51.516 86.475 52.44 86.475 53.574V60H83.85V53.91C83.85 52.916 83.612 52.174 83.136 51.684C82.674 51.194 82.023 50.949 81.183 50.949C80.567 50.949 80.021 51.075 79.545 51.327C79.069 51.579 78.698 51.957 78.432 52.461C78.18 52.951 78.054 53.574 78.054 54.33V60H75.429V48.786H77.928V51.81L77.487 50.886C77.879 50.172 78.446 49.626 79.188 49.248C79.944 48.856 80.812 48.66 81.792 48.66ZM91.947 57.501L92.01 54.204L97.869 48.786H101.019L96.042 53.784L94.656 54.939L91.947 57.501ZM89.805 60V44.418H92.43V60H89.805ZM98.268 60L94.173 54.939L95.832 52.839L101.46 60H98.268Z"
                        fill="white"
                      />
                    </svg>
                  ) : (
                    <svg
                      height="36"
                      viewBox="0 0 155 78"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M116 0H0V78H116L155 39L116 0Z" fill="#00599B" />
                      <path
                        d="M42.5396 33L37.6676 18.3H40.5026L44.8496 31.593H43.4426L47.9576 18.3H50.4776L54.8666 31.593H53.5016L57.9536 18.3H60.5576L55.6856 33H52.7876L48.7766 21.009H49.5326L45.4586 33H42.5396ZM66.9598 33.147C65.7138 33.147 64.6218 32.902 63.6838 32.412C62.7598 31.908 62.0388 31.222 61.5208 30.354C61.0168 29.486 60.7648 28.499 60.7648 27.393C60.7648 26.273 61.0098 25.286 61.4998 24.432C62.0038 23.564 62.6898 22.885 63.5578 22.395C64.4398 21.905 65.4408 21.66 66.5608 21.66C67.6528 21.66 68.6258 21.898 69.4798 22.374C70.3338 22.85 71.0058 23.522 71.4958 24.39C71.9858 25.258 72.2308 26.28 72.2308 27.456C72.2308 27.568 72.2238 27.694 72.2098 27.834C72.2098 27.974 72.2028 28.107 72.1888 28.233H62.8438V26.49H70.8028L69.7738 27.036C69.7878 26.392 69.6548 25.825 69.3748 25.335C69.0948 24.845 68.7098 24.46 68.2198 24.18C67.7438 23.9 67.1908 23.76 66.5608 23.76C65.9168 23.76 65.3498 23.9 64.8598 24.18C64.3838 24.46 64.0058 24.852 63.7258 25.356C63.4598 25.846 63.3268 26.427 63.3268 27.099V27.519C63.3268 28.191 63.4808 28.786 63.7888 29.304C64.0968 29.822 64.5308 30.221 65.0908 30.501C65.6508 30.781 66.2948 30.921 67.0228 30.921C67.6528 30.921 68.2198 30.823 68.7238 30.627C69.2278 30.431 69.6758 30.123 70.0678 29.703L71.4748 31.32C70.9708 31.908 70.3338 32.363 69.5638 32.685C68.8078 32.993 67.9398 33.147 66.9598 33.147ZM80.9683 33.147C80.0163 33.147 79.1693 32.937 78.4273 32.517C77.6853 32.097 77.0973 31.467 76.6633 30.627C76.2433 29.773 76.0333 28.695 76.0333 27.393C76.0333 26.077 76.2503 24.999 76.6843 24.159C77.1323 23.319 77.7273 22.696 78.4693 22.29C79.2253 21.87 80.0583 21.66 80.9683 21.66C82.0743 21.66 83.0473 21.898 83.8873 22.374C84.7413 22.85 85.4133 23.515 85.9033 24.369C86.4073 25.223 86.6593 26.231 86.6593 27.393C86.6593 28.555 86.4073 29.563 85.9033 30.417C85.4133 31.271 84.7413 31.943 83.8873 32.433C83.0473 32.909 82.0743 33.147 80.9683 33.147ZM74.7523 33V17.418H77.3773V24.39L77.1673 27.372L77.2513 30.354V33H74.7523ZM80.6743 30.9C81.3043 30.9 81.8643 30.76 82.3543 30.48C82.8583 30.2 83.2573 29.794 83.5513 29.262C83.8453 28.73 83.9923 28.107 83.9923 27.393C83.9923 26.665 83.8453 26.042 83.5513 25.524C83.2573 24.992 82.8583 24.586 82.3543 24.306C81.8643 24.026 81.3043 23.886 80.6743 23.886C80.0443 23.886 79.4773 24.026 78.9733 24.306C78.4693 24.586 78.0703 24.992 77.7763 25.524C77.4823 26.042 77.3353 26.665 77.3353 27.393C77.3353 28.107 77.4823 28.73 77.7763 29.262C78.0703 29.794 78.4693 30.2 78.9733 30.48C79.4773 30.76 80.0443 30.9 80.6743 30.9ZM92.6138 33.147C91.6758 33.147 90.7728 33.028 89.9048 32.79C89.0508 32.538 88.3718 32.237 87.8678 31.887L88.8758 29.892C89.3798 30.214 89.9818 30.48 90.6818 30.69C91.3818 30.9 92.0818 31.005 92.7818 31.005C93.6078 31.005 94.2028 30.893 94.5668 30.669C94.9448 30.445 95.1338 30.144 95.1338 29.766C95.1338 29.458 95.0078 29.227 94.7558 29.073C94.5038 28.905 94.1748 28.779 93.7688 28.695C93.3628 28.611 92.9078 28.534 92.4038 28.464C91.9138 28.394 91.4168 28.303 90.9128 28.191C90.4228 28.065 89.9748 27.89 89.5688 27.666C89.1628 27.428 88.8338 27.113 88.5818 26.721C88.3298 26.329 88.2038 25.811 88.2038 25.167C88.2038 24.453 88.4068 23.837 88.8128 23.319C89.2188 22.787 89.7858 22.381 90.5138 22.101C91.2558 21.807 92.1308 21.66 93.1388 21.66C93.8948 21.66 94.6578 21.744 95.4278 21.912C96.1978 22.08 96.8348 22.318 97.3388 22.626L96.3308 24.621C95.7988 24.299 95.2598 24.082 94.7138 23.97C94.1818 23.844 93.6498 23.781 93.1178 23.781C92.3198 23.781 91.7248 23.9 91.3328 24.138C90.9548 24.376 90.7658 24.677 90.7658 25.041C90.7658 25.377 90.8918 25.629 91.1438 25.797C91.3958 25.965 91.7248 26.098 92.1308 26.196C92.5368 26.294 92.9848 26.378 93.4748 26.448C93.9788 26.504 94.4758 26.595 94.9658 26.721C95.4558 26.847 95.9038 27.022 96.3098 27.246C96.7298 27.456 97.0658 27.757 97.3178 28.149C97.5698 28.541 97.6958 29.052 97.6958 29.682C97.6958 30.382 97.4858 30.991 97.0658 31.509C96.6598 32.027 96.0788 32.433 95.3228 32.727C94.5668 33.007 93.6638 33.147 92.6138 33.147ZM99.9564 33V21.786H102.581V33H99.9564ZM101.279 19.938C100.789 19.938 100.383 19.784 100.061 19.476C99.7534 19.168 99.5994 18.797 99.5994 18.363C99.5994 17.915 99.7534 17.544 100.061 17.25C100.383 16.942 100.789 16.788 101.279 16.788C101.769 16.788 102.168 16.935 102.476 17.229C102.798 17.509 102.959 17.866 102.959 18.3C102.959 18.762 102.805 19.154 102.497 19.476C102.189 19.784 101.783 19.938 101.279 19.938ZM110.248 33.147C109.016 33.147 108.064 32.832 107.392 32.202C106.72 31.558 106.384 30.613 106.384 29.367V19.308H109.009V29.304C109.009 29.836 109.142 30.249 109.408 30.543C109.688 30.837 110.073 30.984 110.563 30.984C111.151 30.984 111.641 30.83 112.033 30.522L112.768 32.391C112.46 32.643 112.082 32.832 111.634 32.958C111.186 33.084 110.724 33.147 110.248 33.147ZM104.536 23.97V21.87H112.012V23.97H104.536ZM119.829 33.147C118.583 33.147 117.491 32.902 116.553 32.412C115.629 31.908 114.908 31.222 114.39 30.354C113.886 29.486 113.634 28.499 113.634 27.393C113.634 26.273 113.879 25.286 114.369 24.432C114.873 23.564 115.559 22.885 116.427 22.395C117.309 21.905 118.31 21.66 119.43 21.66C120.522 21.66 121.495 21.898 122.349 22.374C123.203 22.85 123.875 23.522 124.365 24.39C124.855 25.258 125.1 26.28 125.1 27.456C125.1 27.568 125.093 27.694 125.079 27.834C125.079 27.974 125.072 28.107 125.058 28.233H115.713V26.49H123.672L122.643 27.036C122.657 26.392 122.524 25.825 122.244 25.335C121.964 24.845 121.579 24.46 121.089 24.18C120.613 23.9 120.06 23.76 119.43 23.76C118.786 23.76 118.219 23.9 117.729 24.18C117.253 24.46 116.875 24.852 116.595 25.356C116.329 25.846 116.196 26.427 116.196 27.099V27.519C116.196 28.191 116.35 28.786 116.658 29.304C116.966 29.822 117.4 30.221 117.96 30.501C118.52 30.781 119.164 30.921 119.892 30.921C120.522 30.921 121.089 30.823 121.593 30.627C122.097 30.431 122.545 30.123 122.937 29.703L124.344 31.32C123.84 31.908 123.203 32.363 122.433 32.685C121.677 32.993 120.809 33.147 119.829 33.147ZM63.2884 60V44.418H65.9134V60H63.2884ZM69.3587 60V48.786H71.9837V60H69.3587ZM70.6817 46.938C70.1917 46.938 69.7857 46.784 69.4637 46.476C69.1557 46.168 69.0017 45.797 69.0017 45.363C69.0017 44.915 69.1557 44.544 69.4637 44.25C69.7857 43.942 70.1917 43.788 70.6817 43.788C71.1717 43.788 71.5707 43.935 71.8787 44.229C72.2007 44.509 72.3617 44.866 72.3617 45.3C72.3617 45.762 72.2077 46.154 71.8997 46.476C71.5917 46.784 71.1857 46.938 70.6817 46.938ZM81.792 48.66C82.688 48.66 83.486 48.835 84.186 49.185C84.9 49.535 85.46 50.074 85.866 50.802C86.272 51.516 86.475 52.44 86.475 53.574V60H83.85V53.91C83.85 52.916 83.612 52.174 83.136 51.684C82.674 51.194 82.023 50.949 81.183 50.949C80.567 50.949 80.021 51.075 79.545 51.327C79.069 51.579 78.698 51.957 78.432 52.461C78.18 52.951 78.054 53.574 78.054 54.33V60H75.429V48.786H77.928V51.81L77.487 50.886C77.879 50.172 78.446 49.626 79.188 49.248C79.944 48.856 80.812 48.66 81.792 48.66ZM91.947 57.501L92.01 54.204L97.869 48.786H101.019L96.042 53.784L94.656 54.939L91.947 57.501ZM89.805 60V44.418H92.43V60H89.805ZM98.268 60L94.173 54.939L95.832 52.839L101.46 60H98.268Z"
                        fill="white"
                      />
                    </svg>
                  )}
                </div>
                GET {fullAccess ? "ALL" : "YOUR"}
                <br />
                {fullAccess ? "THE" : "OWN"} PHOTOS
              </div>
              <div className="model-group-type-qr my-2 pb-1">
                from this event
                <br />
                instantly using face recognition
              </div>
              <div className="model-group-type mb-1">SCAN THIS CODE</div>
              <div ref={QRNoDesign} className="w-fit mx-auto mb-1">
                <QRCode value={getLink()} size={160} />
              </div>
              <div className="model-group-type">CLICK A SELFIE</div>
              <div className="color-primary font-13 font-bold">
                U-Code:&nbsp;
                {fullAccess && !isPrivate
                  ? groupDetails?.fGroupCode
                  : groupDetails?.groupCode}
              </div>
              <div
                className="d-flex align-items-center text-center justify-content-center flex-nowrap position-absolute bottom-0 start-50 mb-3 w-100"
                style={{
                  transform: "translateX(-50%)",
                }}
              >
                {branding?.logo && (
                  <div className="photograper-branding col-6 flex-grow-1 flex-shrink-1">
                    <img
                      className="photographer-logo m-0"
                      style={{
                        maxHeight: "60px",
                      }}
                      src={logo.logo}
                    />

                    <h5
                      className="model-group-type"
                      style={{
                        margin: "5px 0",
                        lineHeight: "12px",
                        fontSize: "10px",
                        fontWeight: "600",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: "3",
                        lineClamp: "3",
                        WebkitBoxOrient: "vertical",
                      }}
                    >
                      {`Album by ` + branding?.business_name}
                    </h5>
                  </div>
                )}
                <div className="kwikpic-branding col-6 flex-grow-1 flex-shrink-1">
                  <img
                    className="photographer-logo m-0"
                    src={logo.kwikpicLogo}
                    alt="kwikpic logo"
                  />
                  <h5
                    className="model-group-type"
                    style={{
                      lineHeight: "12px",
                      fontSize: "10px",
                      fontWeight: "600",
                      margin: "5px 0",
                    }}
                  >
                    Technology by Kwikpic
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div
            className="mt-3 d-flex align-items-center"
            style={{
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            <span className="pe-2">App Link</span>
            <DefaultSwitch
              isChecked={!forApp}
              onChange={() => {
                setForApp((a) => !a);
                setQRCodeImage(QR_INIT);
              }}
            />
            <span className="ps-2">Web Link</span>
          </div>
          <div className="mt-4 d-flex justify-content-center flex-wrap gap-12">
            <SecondaryButton
              onClick={downloadQR}
              rounded={false}
              className="px-3 d-flex align-items-center gap-2"
            >
              <img
                src="/assets/icons/download.png"
                alt="download entire pamphlet"
                height={16}
              />
              <span className="text-nowrap">QR with Design</span>
            </SecondaryButton>
            <OutlinedButton
              onClick={downloadQRNoDesign}
              variant="xs"
              className="min-w-auto px-3 d-flex align-items-center gap-2"
            >
              <img
                src="/assets/images/icons/download.png"
                alt="download only the qr code"
                height={16}
              />
              <span className="text-nowrap">Transparent QR</span>
            </OutlinedButton>
          </div>
        </div>
      </ConfirmationModal>
      {/* QR modal */}
    </>
  );
};

export default GroupShareModal;
